import type { ReactNode } from 'react';
import { CLIENT_SCREEN_NAME_ROUTES, FeedbackProvider, type FeedbackSubmission } from '@babomrs/ui';
import { apiClient } from '@babomrs/api-client';

/**
 * Client-portal feedback mount (Story D2 + F2, Epic #9653). Wraps the authenticated
 * app shell in the shared FeedbackProvider (never on PublicLayout): the persistent
 * widget renders AND the Client Portal Assistant can flag incorrect AI output via
 * useFeedback(). The server derives the submitter from the auth token.
 *
 * BR-CP-HOME-012 — the screen list is the CLIENT list (client screens only, never staff ones), each auto-detected
 * from its route; the panel itself is bugs only and is never mounted on the public pages.
 */
export function ClientFeedbackWidget({ children }: { children: ReactNode }) {
  return (
    <FeedbackProvider
      portal="client"
      screens={CLIENT_SCREEN_NAME_ROUTES}
      submit={async (input: FeedbackSubmission) => {
        const res = await apiClient.post<{ trackingReference: string }>('/api/v1/feedback', input);
        return res.trackingReference;
      }}
    >
      {children}
    </FeedbackProvider>
  );
}
